// Convert an ISO 3166-1 alpha-2 country code into the corresponding flag emoji.
// Falls back to a globe glyph when the code is empty/unknown.
export function flagEmoji(code) {
    if (!code) return "🌐";
    const c = String(code).trim().toUpperCase();
    if (c.length !== 2) return "🌐";
    if (c === "LO") return "🏠"; // local / private
    const A = 0x1f1e6;
    return String.fromCodePoint(
        A + c.charCodeAt(0) - 65,
        A + c.charCodeAt(1) - 65,
    );
}

// Localized Polish display names by region code, with fallback to the name
// returned from the geolocation API.
const PL_NAMES = {
    US: "Stany Zjednoczone",
    GB: "Wielka Brytania",
    DE: "Niemcy",
    FR: "Francja",
    PL: "Polska",
    UA: "Ukraina",
    RU: "Rosja",
    BY: "Białoruś",
    LT: "Litwa",
    LV: "Łotwa",
    EE: "Estonia",
    CZ: "Czechy",
    SK: "Słowacja",
    HU: "Węgry",
    AT: "Austria",
    NL: "Holandia",
    BE: "Belgia",
    CH: "Szwajcaria",
    IT: "Włochy",
    ES: "Hiszpania",
    PT: "Portugalia",
    IE: "Irlandia",
    SE: "Szwecja",
    NO: "Norwegia",
    FI: "Finlandia",
    DK: "Dania",
    IS: "Islandia",
    RO: "Rumunia",
    BG: "Bułgaria",
    GR: "Grecja",
    TR: "Turcja",
    HR: "Chorwacja",
    SI: "Słowenia",
    RS: "Serbia",
    BA: "Bośnia i Hercegowina",
    MK: "Macedonia Północna",
    AL: "Albania",
    MD: "Mołdawia",
    MT: "Malta",
    CY: "Cypr",
    CA: "Kanada",
    MX: "Meksyk",
    BR: "Brazylia",
    AR: "Argentyna",
    AU: "Australia",
    NZ: "Nowa Zelandia",
    JP: "Japonia",
    CN: "Chiny",
    KR: "Korea Południowa",
    IN: "Indie",
    ID: "Indonezja",
    PH: "Filipiny",
    TH: "Tajlandia",
    VN: "Wietnam",
    MY: "Malezja",
    SG: "Singapur",
    AE: "Zjednoczone Emiraty Arabskie",
    SA: "Arabia Saudyjska",
    IL: "Izrael",
    EG: "Egipt",
    ZA: "RPA",
    KZ: "Kazachstan",
    KG: "Kirgistan",
};

export function countryName(code, fallback = "") {
    if (!code) return fallback || "Nieznane";
    const c = String(code).trim().toUpperCase();
    if (c === "LO") return "Lokalnie / prywatne";
    return PL_NAMES[c] || fallback || c;
}
